/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { UserContext } from "context";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDProgress from "components/MDProgress";

// ENV Values
const apiUrl = process.env.REACT_APP_API_URL;

export default function data(extended = true) {
  const { user } = useContext(UserContext);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true); // Add loading state

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await fetch(`${apiUrl}/user_events.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userId: user.id,
            isAdmin: user.isAdmin ? user.isAdmin : false,
          }),
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();
        setEvents(data.events);
      } catch (error) {
        console.error("There was an error fetching the events!", error);
      } finally {
        setLoading(false); // Set loading to false when fetch completes
      }
    };

    if (user.id) {
      fetchEvents();
    }
  }, [user]);

  // While fetching data, return loading as true
  if (loading) {
    return { columns: [], rows: [], loading: true };
  }

  const columns = [
    {
      Header: "eventi",
      accessor: "event_name",
      sortType: "alphanumeric",
      align: "left",
      Cell: ({ row }) => (
        <MDBox display="flex" alignItems="center" lineHeight={1}>
          <Link to={`/app/event/${row.original.id}`}>
            <MDTypography
              display="block"
              variant="button"
              fontWeight="medium"
              ml={1}
              lineHeight={1}
              title={`${row.original.address_city} - ${row.original.event_name}`}
            >
              {`${row.original.address_city} - ${row.original.event_name}`.length > 25
                ? `${`${row.original.address_city} - ${row.original.event_name}`.slice(0, 22)}...`
                : `${row.original.address_city} - ${row.original.event_name}`}
            </MDTypography>
          </Link>
        </MDBox>
      ),
    },
  ];

  if (user.isAdmin && extended) {
    columns.push({ Header: "nome", accessor: "name", align: "center", sortType: "alphanumeric" });
    columns.push({
      Header: "nome dell'azienda",
      accessor: "company_name",
      align: "center",
      sortType: "alphanumeric",
    });
  }

  columns.push({ Header: "progressi", accessor: "progress", align: "center" });
  columns.push({ Header: "stati del permesso", accessor: "status", align: "center" });

  if (extended) {
    columns.push({ Header: "azione", accessor: "action", align: "center" });
  }

  const rows = events.map((event) => ({
    id: event.id,
    event_name: event.event_name,
    address_city: event.address_city,
    ...(extended && {
      name: `${event.user_surname} ${event.user_name}`,
      company_name: event.company_name,
    }),
    progress: (
      <MDBox width="8rem">
        <MDProgress
          value={
            event.totalPermissions === "0"
              ? 0
              : Math.floor((100 * event.closedPermissions) / event.totalPermissions)
          }
          color={
            event.closedPermissions === event.totalPermissions && event.totalPermissions > 0
              ? "success"
              : "secondary"
          }
          variant="gradient"
          label={true}
          sx={{
            width: "100%",
            mt: "auto",
          }}
        />
      </MDBox>
    ),
    status: (
      <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
        {event.status}
      </MDTypography>
    ),
    ...(extended && {
      action: (
        <MDTypography component="a" href="#" color="text">
          <Icon>more_vert</Icon>
        </MDTypography>
      ),
    }),
  }));

  return {
    columns,
    rows,
    loading: false, // Add loading status as false when data is available
  };
}

